<template>
    <Field
        :name="name"
        :errors="errors"
        :required="required"
        :label="label"
    >
        <AntSelect
            :id="name"
            v-model="innerValue"
            show-search
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            :class="elementClasses"
            class="w-full"
            v-bind="$attrs"
            @blur="$emit('blur')"
            @search="fetchOptions"
        >
            <AntSpinner
                v-if="fetching"
                slot="notFoundContent"
                size="small"
            />
            <AntSelectOption
                v-for="option of options"
                :key="option[valueKey]"
                :value="option[valueKey]"
            >
                {{ option[nameKey] }}
            </AntSelectOption>
        </AntSelect>
    </Field>
</template>

<script>
import Field from '@/components/field/Field.vue';
import { Select, Spin } from 'ant-design-vue';
import fieldMixin from '@/mixins/fieldMixin';
import debounce from 'lodash/debounce';

export default {
    components: {
        AntSelect: Select,
        AntSelectOption: Select.Option,
        AntSpinner: Spin,
        Field,
    },
    mixins: [fieldMixin],
    props: {
        valueKey: {
            type: String,
            default: 'id',
        },
        nameKey: {
            type: String,
            default: 'name',
        },
        searchKey: {
            type: String,
            default: 's',
        },
        url: {
            type: String,
            required: true,
        },
    },
    data: () => ({      
        fetching: false,
        options: [],
    }),
    methods: {
        fetchOptions: debounce(async function (search) {
            this.options = [];
            this.fetching = true;

            const data = await this.$http.get(`${this.url}?${this.searchKey}=${encodeURIComponent(search)}`);
            
            this.options = data;
            this.fetching = false;    
        }, 600),
    },
};
</script>

<style></style>
